import React, { useState, useEffect, useRef } from 'react'
import SubNav from '../../../components/sub-nav';
import {
  Container,
  Heading,
  Select,
  Stack,
  Button,
  Input,
  Tabs,
  TabList, TabPanels, Tab, TabPanel,
  InputGroup, InputRightElement, Spinner } from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons'
import { useToast } from '@chakra-ui/react'
import { styled } from 'styled-components';
import { colors } from '../../../styles/theme';
import { BsArrowRight } from 'react-icons/bs'
import { naira } from '../../../assets/dashboard/utils';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { decrement, increment } from '../../../store/reducers/loading';
import SearchableDropdown from '../../../components/SearchableDropdown';
import { phone } from '../../../assets/auth';

const Electricity = () => {
  const loadingCount = useSelector((state) => state.loading.count);
  const dispatch = useDispatch();
  const isLoading = () => {
    // console.log(loadingCount);
    return loadingCount > 0;
  }
  const navigate = useNavigate();
  const toast = useToast()

  const [number, setNumber] = useState('')
  const [amount, setAmount] = useState('')
  const [password, setPassword] = useState('')
  const [selectedPlan, setSelectedPlan] = useState('')
  const [discoId, setDiscoId] = useState('')
  const [contractType, setContractType] = useState('prepaid')
  const [verified, setVerified] = useState(false)
  const [meterNumber, setMeterNumber] = useState('')
  const [reference, setReference] = useState('')
  const [meterName, setMeterName] = useState('')
  const [discos, setDiscos] = useState([])
  const [phoneNumber, setPhoneNumber] = useState([])
  const [meterAddress, setMeterAddress] = useState([])
  const [beneficiaries, setBeneficiaries] = useState([])
  const [showPassword, setShowPassword] = useState(false)
  const [selectedBeneficiaryId, setSelectedBeneficiaryId] = useState(null);

  const handleGetData = async () => {
    try {
      dispatch(increment());
      const token = `Bearer ${Cookies.get('Token')}`
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/power/get_discos`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
        },
      });

      if(response.status == 401)  {
        navigate("/auth/login");
      }
      const data = await response.json();
      dispatch(decrement());
      if(response.status > 300) {
        if(response.status == 500) {
          toast({
            title: "Something went wrong",
            status: 'error',
            description: "Please contact support",
            isClosable: true,
          })
        }
        toast({
          title: data.message,
          status: 'error',
          description: "",
          isClosable: true,
        })
        return;
      }
      setDiscos(data.data.map(x => ({value: x.id, label: x.name}) ))


    } catch (err) {
      dispatch(decrement());
      // Handle errors
      // console.log(err)
      toast({
          title: "Netork Error",
          status: 'error',
          description: "Check you internet connection",
          isClosable: true,
        })
    }
  }

  const handleGetBeneficiary = async () => {
    try {
      dispatch(increment());
      const token = `Bearer ${Cookies.get('Token')}`
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/power/meter_no`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
        },
      });

      if(response.status == 401)  {
        navigate("/auth/login");
      }
      const data = await response.json();
      dispatch(decrement());
      if(response.status > 300) {
        if(response.status == 500) {
          toast({
            title: "Something went wrong",
            status: 'error',
            description: "Please contact support",
            isClosable: true,
          })
        }
        toast({
          title: data.message,
          status: 'error',
          description: "",
          isClosable: true,
        })
        return;
      }
      setBeneficiaries(data.data)


    } catch (err) {
      dispatch(decrement());
      // Handle errors
      // console.log(err)
      toast({
          title: "Netork Error",
          status: 'error',
          description: "Check you internet connection",
          isClosable: true,
        })
    }
  }

  const handleSelectedDisco = async (selectedOption) => {
    const selectedId = selectedOption;
    // console.log(selectedId)
    setDiscoId(selectedId)

  }

  const handleSelectedBeneficiary = async (selectedOption) => {
    
  
    setVerified(false)
    let selectedBeneficiaryId = selectedOption;
    setSelectedBeneficiaryId(selectedBeneficiaryId)
    if(selectedBeneficiaryId == 0) return;
    if (!selectedBeneficiaryId || selectedBeneficiaryId.length < 1) return;
    let beneficiary = beneficiaries.filter(x => x.id == selectedBeneficiaryId)[0];
    setMeterNumber(beneficiary.meter_number);
    setDiscoId(beneficiary.disco_id);
    setContractType(beneficiary.contract_type);
  }

  const verifyMeter = async () => {
    const token = `Bearer ${Cookies.get('Token')}`
    try {
      dispatch(increment());
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/power/verify_meter`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
        },
        body: JSON.stringify({
          disco_id: discoId,
          meter_no: meterNumber,
          contract_type: contractType
        }), // Convert the form data to JSON
      });

      if(response.status == 401)  {
        navigate("/auth/login");
      }
      const data = await response.json();
      dispatch(decrement());
      if(response.status > 300) {
        if(response.status == 500) {
          toast({
            title: "Something went wrong",
            status: 'error',
            description: "Please contact support",
            isClosable: true,
          })
        }
        toast({
          title: data.message,
          status: 'error',
          description: "",
          isClosable: true,
        })
        return;
      }
      if (!data.status) {
        // console.log(data.status)
        toast({
          title: "An error occurred",
          status: 'error',
          description: data?.message,
          isClosable: true,
        })
      } else {
        setReference(data.data.reference_id)
        setMeterName(data.data.customer_name)
        setMeterAddress(data.data.customer_address)
        setVerified(true)
      }
    } catch (err) {
      dispatch(decrement());
      // Handle errors
      // console.log(err)
      toast({
          title: "Netork Error",
          status: 'error',
          description: "Check you internet connection",
          isClosable: true,
        })
    }
  }

  const handlerChangeMeterNumber = async (event) => {
    event.preventDefault();
    setVerified(false)
    const meterNumberS = event.target.value;
    setMeterNumber(meterNumberS);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!reference && !password && !amount && !discoId) {
      return toast.error("please provide all values");
    }
    const token = `Bearer ${Cookies.get('Token')}`
    try {
      dispatch(increment());
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/power/vend`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
        },
        body: JSON.stringify({
          disco_id: discoId,
          reference_id: reference,
          amount: amount,
          payment_method: 'wallet',
          phone_number: phoneNumber,
          password: password,
          payment_reference: reference,
        }), // Convert the form data to JSON
      });

      if(response.status == 401)  {
        navigate("/auth/login");
      }
      const data = await response.json();
      dispatch(decrement());
      if(response.status > 300) {
        if(response.status == 500) {
          toast({
            title: "Something went wrong",
            status: 'error',
            description: "Please contact support",
            isClosable: true,
          })
        }
        toast({
          title: data.message,
          status: 'error',
          description: "",
          isClosable: true,
        })
        return;
      }
      if (!data.status) {
        // console.log(data.status)
        toast({
          title: "An error occurred",
          status: 'error',
          description: data?.message,
          isClosable: true,
        })
      } else {
        const msgToPass = "You meter purchase was successful!"
        navigate("/dashboard/success", { state: { type: 'power', data: msgToPass, transaction: data.data } });

      }
    } catch (err) {
      dispatch(decrement());
      // Handle errors
      // console.log(err)
      toast({
          title: "Netork Error",
          status: 'error',
          description: "Check you internet connection",
          isClosable: true,
        })
    }

    // // console.log(user);
  };

  const getBeneficiaryOptions = () => {

    let options = beneficiaries.map(item => {
      return {
        value: item.id,
        label: `${item?.name} (${item?.meter_number})`
      }
    });

    return [{value: 0, label: 'New beneficiary'},...options];
   
  }
  useEffect(() => {
    handleGetData();
    handleGetBeneficiary();
  }, []);

  return (
    <div>
      <Wrapper>
        <SubNav title={'Electricity'} />
        <Container maxW={{ base: 'sm', md: 'md', lg: 'lg' }} my='2rem'>
          <Heading fontSize={'24px'} fontWeight='700' fontFamily={'inter'} textAlign='center' mb={'1rem'}>Buy Electricity</Heading>
          <Tabs variant='soft-rounded' colorScheme='blue' >
            <TabList bg='rgba(66, 164, 217, 1)' borderRadius='.5rem' p='1rem' color='#fff' gap={{ base: '.5rem'}}>
              <Tab color='#fff' w='50%' border='none' onClick={() => setContractType('prepaid')}>Prepaid</Tab>
              <Tab color='#fff' w='50%' border='none' onClick={() => setContractType('postpaid')}>Postpaid</Tab>
            </TabList>
            <TabPanels>


              {[1, 2].map(item => (
                <TabPanel className='daily-plan'>
                  <form onSubmit={handleSubmit}>

                    <label>Select Beneficiary</label>
                    <InputContainer style={{ margin: '1.2rem 0', justifyContent: 'space-between' }}>
                      <SearchableDropdown  options={getBeneficiaryOptions()} onSelect={handleSelectedBeneficiary} defaultText={'Select Beneficiary'} value={selectedBeneficiaryId} />

                      
                    </InputContainer>

                    <label>Select Disco</label>
                    <InputContainer style={{ margin: '1.2rem 0', justifyContent: 'space-between' }}>
                    <SearchableDropdown options={discos} onSelect={handleSelectedDisco} defaultText={'Select Disco'} value={discoId} />

                      
                    </InputContainer>

                    <label>Meter Number</label>
                    <InputContainer style={{ margin: '1.2rem 0' }}>
                      <input autocomplete="off" name={Math.random().toString(36).substr(2, 10)}
                      style={{"flex": "1"}}
                        type="text"
                        value={meterNumber}
                        onChange={handlerChangeMeterNumber}

                      />
                    </InputContainer>

                    {!verified &&
                      <Stack spacing={10} pt={2}>
                        {isLoading() ?
                          <Button
                            loadingText="Loading"
                            size="lg"
                            bg={'blue.400'}
                            color={'white'}
                            _hover={{
                              bg: 'blue.500',
                            }}>
                            <Spinner />
                          </Button>
                          :
                          <Button
                            loadingText="Loading"
                            size="lg"
                            onClick={verifyMeter}
                            bg={'blue.400'}
                            color={'white'}
                            _hover={{
                              bg: 'blue.500',
                            }}>
                            Continue <BsArrowRight style={{ fontSize: '22px', marginLeft: '.7rem', fontWeight: '600' }} />
                          </Button>
                        }
                      </Stack>
                    }

                    {verified && <>
                      <label>Customer Name</label>
                      <InputContainer style={{ margin: '1.2rem 0' }}>
                        <input autocomplete="off" name={Math.random().toString(36).substr(2, 10)}
                          style={{"flex": "1"}}
                          type="text"
                          value={meterName}
                        />
                      </InputContainer>

                      {/* ================ meter address ==============  */}
                      <label>Meter Address</label>
                      <InputContainer style={{ margin: '1.2rem 0' }}>
                        <input autocomplete="off" name={Math.random().toString(36).substr(2, 10)}
                        style={{"flex": "1"}}
                          type="text"
                          value={meterAddress}
                        />
                      </InputContainer>

                      {/* ==================== amount ================== */}
                      <label>Amount</label>
                      <InputContainer style={{ margin: '1.2rem 0' }}>
                        <img src={naira} alt={'icon'} />
                        <input autocomplete="off" name={Math.random().toString(36).substr(2, 10)}
                        style={{"flex": "1"}}
                          type="text"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}

                        />
                      </InputContainer>

                      {/* =============== payment option =============  */}
                      <label>Pay with</label>
                      <InputContainer style={{ margin: '1.2rem 0' }}>
                        <Select variant={'unstyled'}>
                          <option value={'wallet'}>My Wallet </option>
                        </Select>
                      </InputContainer>

                      {/* =============== phone number =============  */}
                      <label>Phone Number</label>
                      <InputContainer style={{ margin: '1.2rem 0' }}>
                        <img src={phone} alt={'icon'} />
                        <input autocomplete="off" name={Math.random().toString(36).substr(2, 10)}
                        style={{"flex": "1"}}
                          type="text"
                          value={phoneNumber}
                          onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                      </InputContainer>

                      {/* ================= password ================ */}
                      <label>Password</label>
                      <InputContainer style={{ margin: '1.2rem 0', justifyContent: 'space-between' }}>
                        <InputGroup p={0} m={0}>
                          <Input 
                            style={{"flex": "1"}}
                            type={showPassword ? 'text' : 'password'} 
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            variant='unstyled'
                            required />
                          <InputRightElement h={'full'}>
                            <Button
                              variant={'ghost'}
                              _focus={{
                                border: 'none',
                                outline: 'none',
                                background: 'transparent'
                              }}
                              _hover={{
                                background: 'transparent'
                              }}
                              onClick={() => setShowPassword((showPassword) => !showPassword)}>
                              {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                            </Button>
                          </InputRightElement>
                        </InputGroup>
                      </InputContainer>

                      <Stack spacing={10} pt={2}>
                        {isLoading() ?
                          <Button
                            loadingText="Loading"
                            size="lg"
                            bg={'blue.400'}
                            color={'white'}
                            _hover={{
                              bg: 'blue.500',
                            }}>
                            <Spinner />
                          </Button>
                          :
                          <Button
                            loadingText="Loading"
                            size="lg"
                            type='submit'
                            bg={'blue.400'}
                            border='none'
                            color={'white'}
                            _hover={{
                              bg: 'blue.500',
                            }}>
                            Continue <BsArrowRight style={{ fontSize: '22px', marginLeft: '.7rem', fontWeight: '600' }} />
                          </Button>
                        }

                      </Stack>
                    </>}
                  </form>
                </TabPanel>
              ))}

            </TabPanels>
          </Tabs>
        </Container>
      </Wrapper>
    </div>
  )
}

export default Electricity


const Wrapper = styled.div`
    background: #F3F3F3;
    padding-bottom: 4rem;
`;

const InputContainer = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;

    height: 60px;
    
    border-radius: 12px;
    border: 1px solid ${colors.textColor};
    background: #F5F7FB;
    box-shadow: 0px 4px 120px 0px rgba(127, 135, 158, 0.10);
    
    padding: 8px 10px;
    margin-bottom: 1rem;
  
  h3 {
    background: rgba(66, 164, 217, .16);
    color: ${colors.primaryColor};
    border-radius: 15px;
    width: 55px;
    margin-right: .6rem;
    /* opacity: 0.16; */
    padding: 10px 14px;

    @media (max-width: 992px) {
      padding: 9px 12px;
    }

  }
  
  input {
    background: transparent;
  }
  input:focus {
    border: none;
    outline: none;
  }

  img {
    align-self: center;
    margin: 0 1rem;
  }

  svg {
    font-size: 18px;
    font-weight: 600;
  }
`;